import React from 'react'
import common from '@/public/common'
import PropTypes from 'prop-types'
import styles from './SearchProductItem.module.less'
import { Button,Card } from 'antd'
import {qwWxShareFn} from '../utils'
import _ from 'lodash'

function SearchProductItem(props) {
  const { data,brandName } = props
  const getData=(key,place,fn)=>{
    if((place&&typeof place!=='string')){
      return place(data[key])
    }else if(fn){
      return fn(data[key])
    }else{
      return _.get(data,key,place||'--')
    }
  }
  const wxShareFn=(data)=>{
    const {itemname,image,itemid} = data
    const _link = '/pages/productdetail/productdetail.html?itemid='+itemid
    const _webUrl = `${common.m_main_url}item${itemid}.html`
    qwWxShareFn({
      title:itemname,
      imgUrl:image.replace(/\/\d+-\d+\//g, '/500-500/'),
      link:_link,
      brandName:brandName,
      webUrl:_webUrl
    })
  }
  return (
    <Card hoverable className={styles.SearchProductItem}>
        <p className={styles.proName}>{getData('itemname')}</p>  
        <section className={styles.contents}>
          <img src={getData('image')}></img>
          <div className={styles.info}>
            <p className={styles.price}>
              ￥
              <span className={styles.priceNum}>{getData('price.sigo')}</span>
              <span style={{textDecoration:'line-through',fontWeight:400,marginLeft:8}}>{`￥${getData('price.market')}`}</span>
            </p>
            <div className={styles.footer}>
              <span className={styles.code}>{getData('itemcode')}</span>
              <Button size='small' type='primary' onClick={()=>{
                wxShareFn(data)
              }}>发送</Button>
            </div>
          </div>
        </section>  
    </Card>
  )
}

SearchProductItem.propTypes = {
  data:PropTypes.object.isRequired,
  brandName:PropTypes.string.isRequired
}

export default SearchProductItem



// WEBPACK FOOTER //
// ./src/pages/udeskSide/components/SearchProductItem.js